<nz-space class="mobile-report-control">
  <app-customer-select #fromSelect  [showAddNewButton]="false" [(ngModel)]="from" class="report-control"
    (ngModelChange)="fromChange.emit($event)" valueField="code">
  </app-customer-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-customer-select  [showAddNewButton]="false" #toSelect [(ngModel)]="to" class="report-control"
    (ngModelChange)="toChange.emit($event)" valueField="code">
  </app-customer-select>
</nz-space>